// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2re1B","content":"ManualTimeModal_content__iXjNU"};